/**
 * wishlist.js — نغمة ستور (V3)
 * ------------------------------------------------------------
 * المفضلة: محفوظة محليًا فقط عبر localStorage على متصفح/جهاز العميل
 * الحالي (المفتاح naghmah:wishlist:v1) — لا مزامنة مع حساب Shopify، لا
 * مزامنة بين الأجهزة، لا Customer Account API، لا App. صيغة كل عنصر
 * مخزَّن: { id, handle, url, addedAt } فقط — لا سعر ولا مخزون ولا عنوان
 * مخزَّن هنا إطلاقًا؛ بيانات العرض الفعلية (صورة/عنوان/سعر/توفر) تُجلب
 * حديثًا من Shopify عبر Section Rendering API عند عرض صفحة المفضلة
 * (sections/wishlist-product-card.liquid)، لا من localStorage.
 *
 * مستمع نقر واحد مفوَّض (delegated) على مستوى document لكل من: تبديل
 * المفضلة [data-wishlist-toggle]، مسح الجميع [data-wishlist-clear-all]،
 * إعادة محاولة تحميل بطاقة [data-wishlist-retry]، وإزالة عنصر غير متاح
 * [data-wishlist-remove-unavailable] — بنفس نمط product-card.js/
 * cart-drawer.js المعتمد في بقية الثيم.
 *
 * تصحيحات V4 (بطلب صريح بعد مراجعة V3 الفعلية — إصلاحات صغيرة ونهائية،
 * بلا أي تغيير على معمارية Run/Global Scheduler التي نجحت في اختبار
 * صاحبة المشروع المحلي):
 * أ) sanitizeItems: الترتيب أصبح Filter → Normalize → Sort (الأحدث أولًا)
 *    → إزالة تكرار id → إزالة تكرار handle → Slice — بدل الترتيب القديم
 *    (Dedup قبل Sort) الذي كان يجعل أول نسخة في مصفوفة التخزين تفوز حتى
 *    لو كانت أقدم من نسخة مكررة لاحقة. Set تحل محل الكائنات العادية {}
 *    لتفادي أي تأثير لمفاتيح مثل __proto__/constructor على إزالة التكرار.
 * ب) normalizeAddedAt: تحقق صارم عبر typeof value !== "number" أولًا —
 *    لا يقبل نصوصًا رقمية ("999") كما كان Number(value) يفعل سابقًا.
 * ج) schedulerPump: entry.taskFn(done) داخل try/catch — استثناء متزامن
 *    من مهمة لا يُبقي فتحة Scheduler مشغولة للأبد.
 * د) loadOneCard: مسار العرض النهائي (renderUnavailable/renderNetworkError/
 *    applyCardHtml) داخل try/catch يضمن استدعاء settle() مرة واحدة دائمًا
 *    حتى لو رمى DOMParser/querySelector/إسناد innerHTML استثناءً.
 *
 * تصحيحات V3 (بطلب صريح بعد مراجعة V2 الفعلية — إعادة بناء جوهرية
 * لمجدوِل تحميل بطاقات صفحة المفضلة):
 * 1) نموذج "Run" مستقل لكل جولة تهيئة بدل عدّادات مشتركة عبر الأجيال:
 *    كل root يملك { sequence, currentRun }؛ كل جولة تهيئة تُنشئ Run جديدة
 *    { id, cancelled, controllers: Set, pendingTasks: Set } وتُلغي الـRun
 *    السابقة بأمان (بلا تصفير عدّاد تستخدمه Requests من جيل مختلف).
 * 2) Global Scheduler واحدة (wishlistFetchScheduler) لكل طلبات المفضلة
 *    عبر كل أقسام main-wishlist معًا — الحد الحقيقي عبر الصفحة كلها هو
 *    CONCURRENCY_LIMIT (4)، لا 4 لكل قسم على حدة.
 * 3) Controller يبقى في run.controllers حتى اكتمال fetch وres.text()
 *    وDOMParser والتطبيق معًا — تنظيف واحد في مسار .then نهائي موحَّد،
 *    محمي من الاستدعاء المكرر عبر once().
 * 4) إضافة محلية (من نفس التبويب) تُعيد تهيئة كل أقسام main-wishlist
 *    فورًا (لا الاكتفاء بمزامنة الأزرار)؛ الإزالة تبقى حذفًا تدريجيًا
 *    للحفاظ على التركيز.
 * 5) sanitizeItems صريحة: تصفية/تطبيع/ترتيب/إزالة تكرار/حد 100 موحَّدة،
 *    تُستخدم من readItems (مع إصلاح Best Effort بلا Recursion) ومن
 *    addItem معًا.
 * 6) removeItem تُنفِّذ writeItems دائمًا (تحقق حقيقي من قابلية الكتابة)
 *    بدل افتراض النجاح حين لا يوجد العنصر أصلًا.
 * 7) تركيز مبني على Index داخل قائمة البطاقات الأصلية بدل الجار المباشر
 *    (يدعم حذف عدة بطاقات دفعة واحدة بأمان)؛ مسح الجميع يُعيد تهيئة كل
 *    الأقسام ويُركِّز عنوان الحالة الفارغة في القسم الذي بدأ منه المسح.
 * 8) shopify:section:unload يدعم كون wrapper نفسه قسم Wishlist أو يحويه،
 *    ويُلغي Run الخاصة بذلك الجذر فقط دون التأثير على أقسام أخرى.
 * 9) كل إصلاحات V2 الصحيحة محفوظة: مزامنة aria-pressed فور تحميل
 *    البطاقة، storage event وإعادة تهيئة كل الأقسام، WeakMap لكل root،
 *    إصلاح الصورة الثانية، Live Region، رسائل added/removed/storage_error.
 */
(function () {
  "use strict";

  var STORAGE_KEY = "naghmah:wishlist:v1";
  var MAX_ITEMS = 100;
  var CONCURRENCY_LIMIT = 4;
  var SECTION_ID = "wishlist-product-card";

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;
  Naghmah.strings = Naghmah.strings || {};

  var toggleAndPageListenersBound = false;

  /* ======================================================================
     دالة مساعدة عامة: تضمن تنفيذ fn مرة واحدة بالضبط مهما استُدعيت
     الدالة الناتجة عدة مرات (بند 2/3: "دالة finish/settle محمية من
     الاستدعاء المكرر").
     ====================================================================== */
  function once(fn) {
    var called = false;
    return function () {
      if (called) return;
      called = true;
      return fn.apply(this, arguments);
    };
  }

  /* ======================================================================
     Global Scheduler (بند 2): طابور واحد لكل طلبات Section Rendering
     الخاصة بالمفضلة عبر كل أقسام main-wishlist معًا — الحد الحقيقي عبر
     الصفحة كلها هو CONCURRENCY_LIMIT، وليس لكل قسم على حدة (كان هذا خطأ
     V2: قسمان معروضان معًا كانا يسمحان بثمانية طلبات متزامنة بدل أربعة).
     ====================================================================== */
  var wishlistFetchScheduler = {
    active: 0,
    pending: [] /* كل عنصر: { run, taskFn } */
  };

  function schedulerPump() {
    while (
      wishlistFetchScheduler.active < CONCURRENCY_LIMIT &&
      wishlistFetchScheduler.pending.length > 0
    ) {
      var entry = wishlistFetchScheduler.pending.shift();
      entry.run.pendingTasks.delete(entry);

      /* Run أُلغيت بينما كانت مهمتها لا تزال في الانتظار — تجاوزها بلا
         استهلاك أي فتحة من الحد العالمي (بند 1: لا تصفير عدّاد يخص جيلًا
         آخر، وهنا لا حتى استهلاك فتحة لجيل مُلغى أصلًا). */
      if (entry.run.cancelled) continue;

      wishlistFetchScheduler.active++;
      (function (entry) {
        var done = once(function () {
          wishlistFetchScheduler.active--;
          schedulerPump();
        });
        /* بند ج (V4): استثناء متزامن يُرمى من داخل taskFn نفسها (قبل أي
           Promise) لا يجوز أن يُبقي هذه الفتحة من الحد العالمي مشغولة
           للأبد — done() تُستدعى فورًا في كتلة catch فتُحرَّر الفتحة
           ويستمر الطلب التالي في الطابور. */
        try {
          entry.taskFn(done);
        } catch (error) {
          done();
        }
      })(entry);
    }
  }

  function schedulerEnqueue(run, taskFn) {
    var entry = { run: run, taskFn: taskFn };
    run.pendingTasks.add(entry);
    wishlistFetchScheduler.pending.push(entry);
    schedulerPump();
  }

  /* ======================================================================
     حالة مستقلة لكل قسم Wishlist عبر WeakMap (بند 1 مستمر من V2): كل جذر
     [data-section-type="main-wishlist"] يملك { sequence, currentRun } —
     لا تعارض بين قسمين معروضين معًا.

     "Run": كائن دورة حياة واحدة لجولة تحميل واحدة (تهيئة أولى أو إعادة
     تهيئة). عند بدء Run جديدة، تُلغى القديمة فورًا: تُلغى Controllers
     الخاصة بها (حتى أثناء قراءة الجسم — res.text() — بفضل بقاء الـController
     حية حتى المسار النهائي الموحَّد، بند 3)، وتُحذف مهامها المعلَّقة التي
     لم تبدأ بعد من الطابور العالمي مباشرة — بلا التأثير على أي Run أخرى
     (قسم آخر، أو حتى جولة سابقة أُلغيت هي الأخرى) لأن كل الفحوصات تعتمد
     على مرجع run تحديدًا، لا عدّاد رقمي مشترك قابل للتضارب بين الأجيال.
     ====================================================================== */
  var wishlistPageStates = new WeakMap();

  function getPageState(root) {
    var state = wishlistPageStates.get(root);
    if (!state) {
      state = { sequence: 0, currentRun: null };
      wishlistPageStates.set(root, state);
    }
    return state;
  }

  function cancelRun(run) {
    if (!run || run.cancelled) return;
    run.cancelled = true;

    run.controllers.forEach(function (controller) {
      try {
        controller.abort();
      } catch (err) {
        /* لا شيء يستحق المعالجة. */
      }
    });
    run.controllers.clear();

    /* حذف فعلي لمهام هذه الـRun من الطابور العالمي (لا الاكتفاء بتركها
       وتجاهلها لاحقًا في schedulerPump — إزالة صريحة تمنع أي تراكم غير
       ضروري في الذاكرة لطوابير طويلة). */
    if (run.pendingTasks.size > 0) {
      wishlistFetchScheduler.pending = wishlistFetchScheduler.pending.filter(
        function (entry) {
          return entry.run !== run;
        }
      );
      run.pendingTasks.clear();
    }
  }

  function startNewRun(state) {
    if (state.currentRun) {
      cancelRun(state.currentRun);
    }
    state.sequence += 1;
    var run = {
      id: state.sequence,
      cancelled: false,
      controllers: new Set(),
      pendingTasks: new Set()
    };
    state.currentRun = run;
    return run;
  }

  /* ======================================================================
     طبقة التخزين (localStorage) — كل تعامل داخل try/catch، لا استثناء
     يُسمح له بكسر الصفحة.
     ====================================================================== */
  function getStorage() {
    try {
      return window.localStorage || null;
    } catch (err) {
      return null;
    }
  }

  function isSafeHandle(handle) {
    return typeof handle === "string" && /^[a-z0-9-]+$/.test(handle);
  }

  function isSameOriginProductPath(url) {
    if (typeof url !== "string" || url === "") return false;
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin) return false;
      if (parsed.pathname.indexOf("/products/") === -1) return false;
      return true;
    } catch (err) {
      return false;
    }
  }

  function isValidStoredItem(item) {
    return (
      item &&
      typeof item === "object" &&
      item.id !== undefined &&
      item.id !== null &&
      String(item.id) !== "" &&
      isSafeHandle(item.handle) &&
      isSameOriginProductPath(item.url)
    );
  }

  /* بند ب (V4): تحقق صارم — لا تحويل ضمني عبر Number(value) (كان يقبل
     نصوصًا رقمية مثل "999" باعتبارها صحيحة). القيمة يجب أن تكون بالفعل
     من نوع "number" حقيقي، محدودة (لا NaN ولا Infinity)، وغير سالبة —
     وإلا تُعامَل كـ0. نص رقمي، null، NaN، Infinity، وأي رقم سالب تصبح
     جميعها 0؛ الرقم الحقيقي الموجب فقط يبقى كما هو. */
  function normalizeAddedAt(value) {
    if (
      typeof value !== "number" ||
      !Number.isFinite(value) ||
      value < 0
    ) {
      return 0;
    }
    return value;
  }

  function normalizeStoredItem(item) {
    return {
      id: String(item.id),
      handle: String(item.handle),
      url: String(item.url),
      addedAt: normalizeAddedAt(item.addedAt)
    };
  }

  /* تحليل JSON آمن: أي فساد (نص غير JSON، مصفوفة مفقودة، نوع خاطئ) يُعامَل
     كمفضلة فارغة بدل تعطيل الصفحة بالكامل. */
  function safeParseArray(raw) {
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed;
    } catch (err) {
      return [];
    }
  }

  /* بند أ (V4): sanitizeItems صريحة وموحَّدة — تُستخدم من readItems (تنظيف
     ما يُقرأ من التخزين) ومن addItem (دمج العنصر الجديد مع القائمة
     الحالية بنفس القواعد بالضبط). الترتيب الصحيح الآن: تصفية البيانات
     الصالحة → تطبيع كل عنصر → **ترتيب حسب addedAt تنازليًا أولًا** → إزالة
     التكرار حسب id ثم handle كاحتياط. عكس V3 عمدًا: هناك كان الترتيب
     "Dedup ثم Sort"، فكانت أول نسخة في مصفوفة التخزين المُدخلة (بصرف
     النظر عن addedAt الفعلي) هي التي تفوز عند التكرار — قد تكون نسخة
     أقدم من نسخة مكررة لاحقة في نفس المصفوفة. الآن الفرز يحدث أولًا،
     فتكون النسخة الأحدث (addedAt الأكبر) هي أول ظهور دائمًا حين تصل دورة
     إزالة التكرار إليها، فتفوز هي بالضرورة — بصرف النظر عن ترتيبها
     الأصلي في مصفوفة التخزين. Set (لا كائنات عادية {}) تُستخدَم لتتبّع
     id/handle المُشاهَدة: بيانات localStorage غير موثوقة، وقيمة id أو
     handle قد تُطابق نصيًا مفاتيح مثل "__proto__" أو "constructor" —
     Set.has/add يعملان بمقارنة قيمة مباشرة بلا أي تأثير لهذه الأسماء
     الخاصة على النموذج الأولي لكائن عادي. */
  function sanitizeItems(rawArray) {
    if (!Array.isArray(rawArray)) return [];

    var normalized = rawArray.filter(isValidStoredItem).map(normalizeStoredItem);

    normalized.sort(function (a, b) {
      return b.addedAt - a.addedAt;
    });

    var seenIds = new Set();
    var seenHandles = new Set();
    var deduped = [];
    normalized.forEach(function (item) {
      if (seenIds.has(item.id)) return;
      if (seenHandles.has(item.handle)) return;
      seenIds.add(item.id);
      seenHandles.add(item.handle);
      deduped.push(item);
    });

    return deduped.slice(0, MAX_ITEMS);
  }

  function readItems() {
    var storage = getStorage();
    if (!storage) return [];
    var raw;
    try {
      raw = storage.getItem(STORAGE_KEY);
    } catch (err) {
      return [];
    }
    if (!raw) return [];

    var clean = sanitizeItems(safeParseArray(raw));

    /* إصلاح Best Effort (بند 5): إن اختلفت القائمة النظيفة عن المخزَّنة
       فعليًا (تكرار، ترتيب مختلف، تجاوز الحد، عناصر غير صالحة أُسقطت)،
       نحاول حفظ النسخة النظيفة مباشرة عبر storage.setItem — عمدًا وليس
       عبر استدعاء writeItems()، وذلك لضمان عدم وجود أي استدعاء متبادل
       بين readItems/writeItems (لا Recursion إطلاقًا). فشل هذا الإصلاح
       (QuotaExceededError مثلاً) لا يُعطِّل الصفحة ولا يُغيِّر القيمة
       النظيفة التي ستُعاد للمستدعي على أي حال، ولا يُطلَق أي إعلان نجاح
       زائف — هذا إصلاح صامت خلف الكواليس فقط. */
    try {
      var serialized = JSON.stringify(clean);
      if (raw !== serialized) {
        storage.setItem(STORAGE_KEY, serialized);
      }
    } catch (err) {
      /* فشل الإصلاح — لا مشكلة، clean تُعاد كما هي أدناه بصرف النظر. */
    }

    return clean;
  }

  function writeItems(items) {
    var storage = getStorage();
    if (!storage) return false;
    try {
      storage.setItem(STORAGE_KEY, JSON.stringify(items));
      return true;
    } catch (err) {
      /* QuotaExceededError أو أي منع تخزين آخر — فشل صريح، لا اقتراح
         بديل. المستدعي (addItem/removeItem/clearAllItems) يُرجع false
         بدوره فلا يُعامَل التغيير كأنه نجح في أي مكان آخر بالكود. */
      return false;
    }
  }

  function hasItem(id) {
    if (id === undefined || id === null) return false;
    var idStr = String(id);
    return readItems().some(function (it) {
      return it.id === idStr;
    });
  }

  function addItem(meta) {
    if (!meta) return false;
    var id = meta.id !== undefined && meta.id !== null ? String(meta.id) : "";
    var handle = typeof meta.handle === "string" ? meta.handle : "";
    var url = typeof meta.url === "string" ? meta.url : "";

    if (!id) return false;
    if (!isSafeHandle(handle)) return false;
    if (!isSameOriginProductPath(url)) return false;

    var items = readItems(); /* نظيفة دائمًا بفضل sanitizeItems */
    var newItem = { id: id, handle: handle, url: url, addedAt: Date.now() };

    /* العنصر الجديد أولًا في المصفوفة المُدخلة لـsanitizeItems: عند
       تعارض id/handle مع عنصر قديم، يفوز العنصر الجديد (أحدث addedAt،
       وهو أيضًا أول ظهور في المصفوفة فيفوز في دورة إزالة التكرار). إسقاط
       أقدم عنصر عند تجاوز 100 يحدث هنا بنفس منطق sanitizeItems الموحَّد،
       لا بمنطق slice منفصل كما في V1/V2. */
    var merged = sanitizeItems([newItem].concat(items));
    return writeItems(merged);
  }

  function removeItem(id) {
    if (id === undefined || id === null) return false;
    var idStr = String(id);
    var items = readItems();
    var next = items.filter(function (it) {
      return it.id !== idStr;
    });
    /* بند 6: تنفيذ writeItems دائمًا — حتى حين لم يكن العنصر موجودًا
       أصلًا — لأن هذا التحقق الحقيقي الوحيد من أن localStorage قابلة
       للكتابة فعليًا الآن. الافتراض القديم ("لم يتغيَّر شيء = نجاح
       تلقائي") كان يُخفي فشل تخزين حقيقي (مثال: القراءة تعمل، الكتابة
       تفشل QuotaExceededError) خلف نجاح وهمي. */
    return writeItems(next);
  }

  function clearAllItems() {
    return writeItems([]);
  }

  /* ======================================================================
     Live Region واحدة للإعلانات الصوتية: تُنشأ برمجيًا مرة واحدة فقط عبر
     createElement/textContent — لا HTML خام، لا استخدام innerHTML.
     ====================================================================== */
  function getOrCreateAnnouncer() {
    var el = document.querySelector("[data-wishlist-announcer]");
    if (el) return el;
    el = document.createElement("div");
    el.className = "visually-hidden";
    el.setAttribute("data-wishlist-announcer", "");
    el.setAttribute("aria-live", "polite");
    el.setAttribute("aria-atomic", "true");
    if (document.body) {
      document.body.appendChild(el);
    }
    return el;
  }

  function announce(text) {
    if (!text) return;
    var el = getOrCreateAnnouncer();
    if (!el) return;
    el.textContent = "";
    window.setTimeout(function () {
      el.textContent = text;
    }, 30);
  }

  /* ======================================================================
     مزامنة كل أزرار [data-wishlist-toggle] وعدّادات [data-wishlist-count].
     ====================================================================== */
  function applyButtonState(button, isActive) {
    button.setAttribute("aria-pressed", isActive ? "true" : "false");
    button.classList.toggle("is-wishlisted", isActive);

    var addLabel = button.getAttribute("data-label-add") || "";
    var removeLabel = button.getAttribute("data-label-remove") || "";
    var label = isActive ? removeLabel : addLabel;

    if (label) {
      button.setAttribute("aria-label", label);
      var textEl = button.querySelector("[data-wishlist-toggle-label]");
      if (textEl) textEl.textContent = label;
    }
  }

  function syncToggleButtonsWithin(container, items) {
    if (!container) return;
    items = items || readItems();
    var idSet = {};
    items.forEach(function (it) {
      idSet[it.id] = true;
    });

    var buttons = container.querySelectorAll("[data-wishlist-toggle]");
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var pid = button.getAttribute("data-product-id");
      applyButtonState(button, Boolean(pid && idSet[pid]));
    }
  }

  function syncAllToggleButtons(items) {
    syncToggleButtonsWithin(document, items);
  }

  /* ======================================================================
     Final Integration Audit (2026-07): إصلاح فجوة حقيقية مثبَتة، لا سلوك
     جديد. compare.js يملك منذ Compare V2 آلية مزامنة أزراره بعد أي تبديل
     Combined Listing لصفحة المنتج (استبدال [data-product-page] بالكامل عبر
     assets/product.js — لا يُطلق shopify:section:load/unload الرسميين لأن
     الاستبدال ليس عبر Section Rendering القياسي لمحرر الثيم). صفحة المنتج
     نفسها تحوي أيضًا [data-wishlist-toggle] (نفس الجذر المُستبدَل)، لكن
     wishlist.js — قبل هذا الإصلاح — لم يكن يستمع إطلاقًا لا لـ
     naghmah:product-changed ولا لأي MutationObserver، فيبقى زر المفضلة على
     الجذر الجديد يعرض حالته الافتراضية من Liquid وقت البناء الأول للقسم بدل
     الحالة الفعلية المخزَّنة في localStorage — إلى حين أول تفاعل يدوي معه.
     هذا خطأ حقيقي قابل لإعادة الإنتاج فعليًا (Combined Listing مفعّلة أصلًا
     في product.js)، وليس افتراضًا نظريًا. الإصلاح هنا ينسخ بالضبط نفس آلية
     compare.js المُختبَرة فعليًا (نفس التعليقات التفصيلية عمدًا لتوثيق أنها
     نفس النمط بالحرف)، بلا أي تعديل على assets/product.js أو assets/compare.js:

     (أ) MutationObserver عالمية واحدة فقط على document.body (childList +
         subtree، بلا attributes) — قراءة localStorage مرة واحدة كسولة لكل
         Batch فقط عند وجود عقدة مضافة فعليًا تحمل/تحوي زر مفضلة.
     (ب) مستمع مباشر على naghmah:product-changed (يُطلقه product.js فعليًا
         بعد كل استبدال Combined Listing ناجح، مع event.detail.pageRoot =
         الجذر الجديد المُستورَد) — مزامنة فورية للجذر الجديد تحديدًا.
     ====================================================================== */
  var wishlistMutationObserver = null;

  function syncWishlistButtonsForAddedNode(node, items) {
    if (!node || node.nodeType !== 1) return;

    if (node.matches && node.matches("[data-wishlist-toggle]")) {
      var pid = node.getAttribute("data-product-id");
      applyButtonState(node, Boolean(pid && items.some(function (it) {
        return it.id === pid;
      })));
    }

    if (node.querySelectorAll && node.querySelectorAll("[data-wishlist-toggle]").length > 0) {
      syncToggleButtonsWithin(node, items);
    }
  }

  function initWishlistMutationObserver() {
    if (wishlistMutationObserver) return; /* لا Observer مكررة إطلاقًا */
    if (typeof MutationObserver !== "function") return;
    if (!document.body) return;

    wishlistMutationObserver = new MutationObserver(function (mutationsList) {
      var items = null;
      for (var m = 0; m < mutationsList.length; m++) {
        var addedNodes = mutationsList[m].addedNodes;
        if (!addedNodes || addedNodes.length === 0) continue;

        for (var n = 0; n < addedNodes.length; n++) {
          var node = addedNodes[n];
          if (!node || node.nodeType !== 1) continue;

          var isToggle = node.matches && node.matches("[data-wishlist-toggle]");
          var hasToggleDescendant =
            node.querySelectorAll &&
            node.querySelectorAll("[data-wishlist-toggle]").length > 0;

          if (!isToggle && !hasToggleDescendant) continue;

          if (items === null) items = readItems();
          syncWishlistButtonsForAddedNode(node, items);
        }
      }
    });

    wishlistMutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function updateCountBadges(count) {
    var badges = document.querySelectorAll("[data-wishlist-count]");
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = String(count);
      if (count > 0) {
        badges[i].removeAttribute("hidden");
      } else {
        badges[i].setAttribute("hidden", "hidden");
      }
    }
  }

  /* العناصر العلوية الفعلية للبطاقات فقط داخل شبكة معيّنة: كل بطاقة تحمل
     data-wishlist-item-slot بثبات طوال دورة حياتها، وتحقّق إضافي أن
     العنصر ابن مباشر لغلاف الشبكة يمنع أي التقاط خاطئ لعناصر متداخلة
     (زر التبديل، زر الحذف، زر إعادة المحاولة، كلها تحمل data-product-id
     لنفس المنتج). */
  function getTopLevelCardSlots(grid) {
    var candidates = grid.querySelectorAll(
      '[data-wishlist-item-slot], .wishlist-page__item[data-product-id]'
    );
    var result = [];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].parentNode === grid) {
        result.push(candidates[i]);
      }
    }
    return result;
  }

  function isInsideHiddenParent(el) {
    if (!el) return true;
    return Boolean(el.closest && el.closest("[hidden]"));
  }

  function focusElementForA11y(el) {
    if (!el) return;
    if (isInsideHiddenParent(el)) return; /* لا تركيز عنصر داخل parent مخفي */
    if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");
    el.focus();
  }

  function focusFirstInteractiveOrSelf(el) {
    if (!el) return;
    if (isInsideHiddenParent(el)) return;
    var interactive = el.querySelector(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]'
    );
    if (interactive) {
      interactive.focus();
    } else {
      focusElementForA11y(el);
    }
  }

  function maybeShowEmptyState(root, count) {
    if (!root) return;
    if (typeof count !== "number") count = readItems().length;
    var grid = root.querySelector("[data-wishlist-grid]");
    var emptyState = root.querySelector("[data-wishlist-empty-state]");
    var actions = root.querySelector("[data-wishlist-actions]");
    if (count === 0) {
      if (grid) grid.setAttribute("hidden", "hidden");
      if (emptyState) emptyState.removeAttribute("hidden");
      if (actions) actions.setAttribute("hidden", "hidden");
    } else {
      if (emptyState) emptyState.setAttribute("hidden", "hidden");
      if (actions) actions.removeAttribute("hidden");
      if (grid) grid.removeAttribute("hidden");
    }
  }

  /* بند 7: حذف تدريجي مع تركيز مبني على Index داخل قائمة البطاقات
     الأصلية — يدعم حذف عدة بطاقات دفعة واحدة بأمان (لا يعتمد على
     nextElementSibling/previousElementSibling التي قد تُشير هي الأخرى
     إلى بطاقة ستُحذف ضمن نفس الدفعة). الترتيب الصارم: احسب index البطاقة
     صاحبة التركيز ضمن القائمة الأصلية أولًا → نفِّذ كل عمليات الحذف →
     حدِّث Empty State → اجلب البطاقات المتبقية من DOM بعد الحذف → ركِّز
     نفس الـindex إن وُجد، وإلا آخر بطاقة متبقية، وإلا عنوان الحالة الفارغة
     بعد ظهورها. */
  function syncWishlistPageAfterChangeForRoot(root, items) {
    var grid = root.querySelector("[data-wishlist-grid]");
    if (!grid) return;

    var idSet = {};
    items.forEach(function (it) {
      idSet[it.id] = true;
    });

    var originalSlots = getTopLevelCardSlots(grid);

    var focusedIndex = -1;
    for (var i = 0; i < originalSlots.length; i++) {
      if (originalSlots[i].contains(document.activeElement)) {
        focusedIndex = i;
        break;
      }
    }

    var slotsToRemove = [];
    for (var j = 0; j < originalSlots.length; j++) {
      var slot = originalSlots[j];
      var pid = slot.getAttribute("data-product-id");
      if (pid && !idSet[pid]) {
        slotsToRemove.push(slot);
      }
    }

    var focusWasInRemovedSlot =
      focusedIndex !== -1 && slotsToRemove.indexOf(originalSlots[focusedIndex]) !== -1;

    slotsToRemove.forEach(function (slot) {
      if (slot.parentNode) slot.parentNode.removeChild(slot);
    });

    maybeShowEmptyState(root, items.length);

    if (!focusWasInRemovedSlot) return;

    var remainingSlots = getTopLevelCardSlots(grid);

    if (remainingSlots.length === 0) {
      focusElementForA11y(root.querySelector(".wishlist-page__empty-title"));
      return;
    }

    var targetIndex = focusedIndex < remainingSlots.length ? focusedIndex : remainingSlots.length - 1;
    focusFirstInteractiveOrSelf(remainingSlots[targetIndex]);
  }

  function syncWishlistPageAfterChange(items) {
    var roots = document.querySelectorAll('[data-section-type="main-wishlist"]');
    for (var i = 0; i < roots.length; i++) {
      syncWishlistPageAfterChangeForRoot(roots[i], items);
    }
  }

  /* حذف تدريجي محلي (زر تبديل/إزالة غير متاح) — يُبقي على التركيز
     ويتفادى إعادة تحميل كل البطاقات المتبقية بلا داعٍ. */
  function notifyChange() {
    var items = readItems();
    syncAllToggleButtons(items);
    updateCountBadges(items.length);
    syncWishlistPageAfterChange(items);
    try {
      document.dispatchEvent(
        new CustomEvent("naghmah:wishlist-changed", {
          detail: { count: items.length, items: items }
        })
      );
    } catch (err) {
      /* بيئة قديمة جدًا بلا دعم CustomEvent. */
    }
  }

  /* بند 4: إعادة تهيئة كاملة لكل أقسام main-wishlist المعروضة — تُستخدم
     عند: (أ) إضافة محلية من نفس التبويب (منتج جديد يحتاج جلبًا حقيقيًا
     عبر Section Rendering API، لا مجرد إظهار عنصر موجود؛ يغطي أيضًا حالة
     تجاوز 100 عنصر: sanitizeItems تُسقط أقدم عنصر تلقائيًا، وإعادة
     التهيئة الكاملة تعرض القائمة الجديدة الفعلية بأكملها فورًا بدل شبكة
     قديمة لا تعكس الإسقاط)، (ب) تغيير قادم من تبويب آخر عبر storage
     event، (ج) مسح الجميع. كل استدعاء لـinitWishlistPageSection يبدأ Run
     جديدة تلقائيًا وتُلغي القديمة بأمان (بند 1). */
  function reinitAllWishlistSections() {
    var items = readItems();
    syncAllToggleButtons(items);
    updateCountBadges(items.length);

    document.querySelectorAll('[data-section-type="main-wishlist"]').forEach(function (root) {
      initWishlistPageSection(root);
    });

    try {
      document.dispatchEvent(
        new CustomEvent("naghmah:wishlist-changed", {
          detail: { count: items.length, items: items }
        })
      );
    } catch (err) {
      /* لا شيء يستحق المعالجة. */
    }
  }

  function handleExternalStorageChange() {
    reinitAllWishlistSections();
  }

  /* ======================================================================
     تبديل حالة المفضلة من أي زر [data-wishlist-toggle] في أي قسم.
     ====================================================================== */
  function handleToggleClick(button) {
    var id = button.getAttribute("data-product-id");
    var handle = button.getAttribute("data-product-handle");
    var url = button.getAttribute("data-product-url");
    if (!id) return;

    var wasInWishlist = hasItem(id);
    var success = wasInWishlist ? removeItem(id) : addItem({ id: id, handle: handle, url: url });

    if (!success) {
      /* فشل تخزين فعلي (QuotaExceededError أو localStorage غير متاح) —
         لا تغيير حالة بصري مضلِّل، لا notifyChange/reinit كأن العملية
         نجحت؛ إعلان صريح فقط بالفشل. */
      announce(Naghmah.strings.wishlistStorageError || "");
      return;
    }

    if (wasInWishlist) {
      notifyChange(); /* حذف تدريجي مع حفظ التركيز — بند 4 */
    } else {
      reinitAllWishlistSections(); /* إظهار فوري للمنتج الجديد — بند 4 */
    }

    announce(
      wasInWishlist
        ? Naghmah.strings.wishlistRemoved || ""
        : Naghmah.strings.wishlistAdded || ""
    );
  }

  /* ======================================================================
     صفحة المفضلة: بناء مكان لكل عنصر بالترتيب أولاً، ثم تحميل كل بطاقة
     عبر Section Rendering API عبر Global Scheduler (حد 4 طلبات متزامنة
     حقيقي عبر الصفحة كلها — بند 2).
     ====================================================================== */
  function cssEscapeValue(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }
    return String(value).replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  }

  function buildSectionUrl(productUrl) {
    try {
      var url = new URL(productUrl, window.location.origin);
      url.searchParams.set("section_id", SECTION_ID);
      return url.pathname + url.search;
    } catch (err) {
      return null;
    }
  }

  function setStatusText(statusEl, text) {
    if (!statusEl) return;
    statusEl.textContent = text || "";
  }

  function buildLoadingSlot(item) {
    var slot = document.createElement("div");
    slot.className = "wishlist-page__item-slot";
    slot.setAttribute("data-wishlist-item-slot", "");
    slot.setAttribute("data-product-id", item.id);
    slot.setAttribute("data-product-handle", item.handle);
    slot.setAttribute("aria-busy", "true");

    var loadingText = document.createElement("p");
    loadingText.className = "wishlist-page__item-loading";
    loadingText.textContent = Naghmah.strings.wishlistLoading || "";
    slot.appendChild(loadingText);

    return slot;
  }

  function renderUnavailable(slot, item) {
    slot.innerHTML = "";
    slot.removeAttribute("aria-busy");
    slot.className = "wishlist-page__item wishlist-page__item--unavailable";
    slot.setAttribute("data-product-id", item.id);

    var message = document.createElement("p");
    message.className = "wishlist-page__item-message";
    message.textContent = Naghmah.strings.wishlistUnavailable || "";
    slot.appendChild(message);

    var removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "button button--ghost wishlist-page__item-remove";
    removeButton.setAttribute("data-wishlist-remove-unavailable", "");
    removeButton.setAttribute("data-product-id", item.id);
    removeButton.textContent = Naghmah.strings.wishlistRemove || "";
    slot.appendChild(removeButton);
  }

  function renderNetworkError(slot, item) {
    slot.innerHTML = "";
    slot.removeAttribute("aria-busy");
    slot.className = "wishlist-page__item wishlist-page__item--error";
    slot.setAttribute("data-product-id", item.id);

    var message = document.createElement("p");
    message.className = "wishlist-page__item-message";
    message.textContent = Naghmah.strings.wishlistLoadError || "";
    slot.appendChild(message);

    var retryButton = document.createElement("button");
    retryButton.type = "button";
    retryButton.className = "button button--secondary wishlist-page__item-retry";
    retryButton.setAttribute("data-wishlist-retry", "");
    retryButton.setAttribute("data-product-id", item.id);
    retryButton.setAttribute("data-product-handle", item.handle);
    retryButton.setAttribute("data-product-url", item.url);
    retryButton.textContent = Naghmah.strings.wishlistRetry || "";
    slot.appendChild(retryButton);

    var removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "button button--ghost wishlist-page__item-remove";
    removeButton.setAttribute("data-wishlist-remove-unavailable", "");
    removeButton.setAttribute("data-product-id", item.id);
    removeButton.textContent = Naghmah.strings.wishlistRemove || "";
    slot.appendChild(removeButton);
  }

  /* لا نحقن استجابة الشبكة كاملة دون تحقق — نبحث تحديدًا عن الغلاف
     المتوقع (data-wishlist-rendered-card بنفس product-id هذا العنصر) داخل
     المستند المُحلَّل عبر DOMParser، ونطبّق innerHTML الخاص به هو فقط.
     فور إدراج HTML البطاقة، نبحث داخلها عن كل زر [data-wishlist-toggle]
     ونطبّق حالته فورًا من localStorage الحالية — بلا انتظار أي حدث لاحق؛
     بما أن هذا المنتج بالتعريف موجود في المفضلة، يظهر قلبه ممتلئًا منذ
     لحظة ظهور البطاقة. */
  function applyCardHtml(slot, item, html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var selector =
      '[data-wishlist-rendered-card][data-product-id="' + cssEscapeValue(item.id) + '"]';
    var rendered = doc.querySelector(selector);
    if (!rendered) {
      if (slot.isConnected) renderUnavailable(slot, item);
      return;
    }
    if (!slot.isConnected) return;

    slot.innerHTML = rendered.innerHTML;
    slot.removeAttribute("aria-busy");
    slot.className = "wishlist-page__item";
    slot.setAttribute("data-product-id", item.id);
    slot.setAttribute("data-wishlist-loaded", "true");

    syncToggleButtonsWithin(slot, readItems());
  }

  /* بند 3: Controller يبقى في run.controllers طوال دورة حياة الطلب
     كاملة (fetch + res.text() + DOMParser + تطبيق البطاقة أو معالجة
     الخطأ) — تنظيف واحد فقط في المسار النهائي الموحَّد (.then الأخير في
     السلسلة)، لا عند وصول Headers فقط. هذا يضمن أن AbortController قادر
     فعليًا على إلغاء الطلب حتى أثناء قراءة الجسم (res.text())، لا فقط
     قبل وصول الاستجابة. settle (المُمرَّرة من scheduleCardLoad) تُستدعى
     مرة واحدة بالضبط بغض النظر عن مسار الانتهاء (نجاح/فشل/إلغاء). */
  function loadOneCard(root, run, entry, settle) {
    var item = entry.item;
    var slot = entry.slot;

    if (!isSafeHandle(item.handle) || !isSameOriginProductPath(item.url)) {
      if (slot.isConnected) renderUnavailable(slot, item);
      settle();
      return;
    }

    var fetchUrl = buildSectionUrl(item.url);
    if (!fetchUrl) {
      if (slot.isConnected) renderUnavailable(slot, item);
      settle();
      return;
    }

    var controller = typeof AbortController === "function" ? new AbortController() : null;
    if (controller) run.controllers.add(controller);

    var outcome = null; /* 'unavailable' | 'html' | 'error' | 'abort' */
    var htmlText = null;

    fetch(fetchUrl, {
      headers: { Accept: "text/html" },
      signal: controller ? controller.signal : undefined
    })
      .then(function (res) {
        if (res.status === 404) {
          outcome = "unavailable";
          return null;
        }
        if (!res.ok) {
          throw new Error("wishlist_http_error_" + res.status);
        }
        return res.text();
      })
      .then(function (text) {
        if (outcome !== "unavailable") {
          htmlText = text;
          outcome = "html";
        }
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") {
          outcome = "abort";
        } else {
          outcome = "error";
        }
      })
      .then(function () {
        /* مسار موحَّد نهائي واحد (بند 3 من V3): تنظيف Controller من
           run.controllers هنا فقط — بعد اكتمال fetch وres.text() معًا. */
        if (controller) run.controllers.delete(controller);

        if (run.cancelled || !slot.isConnected || outcome === "abort") {
          settle();
          return;
        }

        /* بند د (V4): renderUnavailable/renderNetworkError/applyCardHtml
           قد ترمي استثناءً متزامنًا (DOMParser فاشل، querySelector على
           بنية غير متوقعة، إسناد innerHTML، إلخ). لا يجوز لأي من هذه
           الاستثناءات أن يمنع استدعاء settle() — وإلا تبقى فتحة الحد
           العالمي مشغولة للأبد وتتوقف بقية البطاقات عن التحميل. settle()
           لا تُستدعى إلا بعد محاولة العرض (نجحت أو فشلت)، لا قبلها. */
        try {
          if (outcome === "unavailable") {
            renderUnavailable(slot, item);
          } else if (outcome === "error") {
            renderNetworkError(slot, item);
          } else if (outcome === "html") {
            applyCardHtml(slot, item, htmlText);
          }
        } catch (renderErr) {
          /* لا شيء إضافي يستحق المعالجة هنا — البطاقة قد تبقى بحالة
             تحميل بصرية غير مكتملة في هذه الحالة الاستثنائية النادرة،
             لكن الأهم أن الـScheduler والـRun لا يتعطلان لبقية البطاقات. */
        }
        settle();
      });
  }

  /* يُدخل مهمة تحميل بطاقة واحدة إلى الـGlobal Scheduler — يُستخدم من
     كل من التحميل الأولي (initWishlistPageSection) وإعادة المحاولة
     (retryCard) معًا، فيبقى الحد الحقيقي 4 طلبات متزامنة عبر الصفحة
     كلها شاملًا كل إعادة محاولة (بند 8 من طلب V2، مُحافَظ عليه هنا ضمن
     البنية الجديدة). */
  function scheduleCardLoad(root, run, entry, onCardSettled) {
    schedulerEnqueue(run, function (schedulerDone) {
      var settle = once(function () {
        schedulerDone();
        onCardSettled();
      });
      if (run.cancelled) {
        settle();
        return;
      }
      loadOneCard(root, run, entry, settle);
    });
  }

  function initWishlistPageSection(root) {
    root =
      root ||
      document.querySelector('[data-section-type="main-wishlist"]');
    if (!root) return;

    var app = root.querySelector("[data-wishlist-app]");
    var grid = root.querySelector("[data-wishlist-grid]");
    if (!app || !grid) return;

    var status = root.querySelector("[data-wishlist-status]");

    var state = getPageState(root);
    var run = startNewRun(state); /* تُلغي أي Run سابقة لهذا الجذر فقط */

    var items = readItems();
    updateCountBadges(items.length);

    grid.innerHTML = "";

    if (items.length === 0) {
      maybeShowEmptyState(root, 0);
      setStatusText(status, "");
      return;
    }

    maybeShowEmptyState(root, items.length);
    setStatusText(status, Naghmah.strings.wishlistLoading || "");

    var entries = items.map(function (item) {
      var slot = buildLoadingSlot(item);
      grid.appendChild(slot);
      return { item: item, slot: slot };
    });

    var remaining = entries.length;
    entries.forEach(function (entry) {
      scheduleCardLoad(root, run, entry, function () {
        remaining--;
        if (remaining === 0 && !run.cancelled) {
          setStatusText(status, "");
          /* مزامنة نهائية لكل الأزرار الجديدة بعد اكتمال الجولة بالكامل —
             طبقة أمان إضافية فوق المزامنة الفورية داخل applyCardHtml. */
          syncAllToggleButtons();
        }
      });
    });
  }

  function retryCard(button) {
    if (button.disabled) return; /* منع طلبين لنفس البطاقة عند نقر متكرر */
    var root = button.closest('[data-section-type="main-wishlist"]');
    if (!root) return;

    var slotEl = button.closest(
      "[data-wishlist-item-slot], .wishlist-page__item, .wishlist-page__item--error"
    );
    if (!slotEl) return;

    button.disabled = true;

    var item = {
      id: button.getAttribute("data-product-id"),
      handle: button.getAttribute("data-product-handle"),
      url: button.getAttribute("data-product-url")
    };

    var freshSlot = buildLoadingSlot(item);
    if (slotEl.parentNode) {
      slotEl.parentNode.replaceChild(freshSlot, slotEl);
    }

    var state = getPageState(root);
    var run = state.currentRun;
    if (!run || run.cancelled) return; /* لا جولة نشطة فعليًا لهذا الجذر */

    /* تمر عبر نفس scheduleCardLoad/Global Scheduler — لا استدعاء مباشر
       لـloadOneCard خارج المجدوِل، فتُحتسب ضمن نفس حد الأربعة طلبات
       العالمي، جنبًا إلى جنب مع أي تحميل أولي أو إعادة محاولة أخرى قيد
       التنفيذ في أي قسم آخر في نفس اللحظة. */
    scheduleCardLoad(root, run, { item: item, slot: freshSlot }, function () {});
  }

  function removeUnavailableCard(button) {
    var id = button.getAttribute("data-product-id");
    var removed = removeItem(id);
    if (!removed) {
      announce(Naghmah.strings.wishlistStorageError || "");
      return; /* فشل فعلي — لا حذف من DOM، لا تحديث عدّاد/aria-pressed */
    }
    notifyChange();
    announce(Naghmah.strings.wishlistRemoved || "");
  }

  function bindDelegatedListeners() {
    if (toggleAndPageListenersBound) return;
    toggleAndPageListenersBound = true;

    document.addEventListener("click", function (evt) {
      var toggleButton = evt.target.closest("[data-wishlist-toggle]");
      if (toggleButton) {
        evt.preventDefault();
        handleToggleClick(toggleButton);
        return;
      }

      var clearButton = evt.target.closest("[data-wishlist-clear-all]");
      if (clearButton) {
        evt.preventDefault();
        var confirmMessage = Naghmah.strings.wishlistClearConfirm || "";
        if (confirmMessage && !window.confirm(confirmMessage)) return;

        var cleared = clearAllItems();
        if (!cleared) {
          announce(Naghmah.strings.wishlistStorageError || "");
          return; /* فشل المسح — لا إعادة تهيئة كأن العملية نجحت */
        }

        /* بند 7: كل الأقسام، لا قسم واحد فقط — ثم تركيز عنوان الحالة
           الفارغة تحديدًا داخل القسم الذي بدأ منه المسح (بعد أن تكون
           initWishlistPageSection ضمن reinitAllWishlistSections قد
           أظهرت الحالة الفارغة فعليًا لذلك القسم). التركيز الصريح هنا
           يضمن أيضًا عدم بقاء التركيز عالقًا داخل data-wishlist-actions
           بعد إخفائها. */
        var originRoot = clearButton.closest('[data-section-type="main-wishlist"]');
        reinitAllWishlistSections();
        announce(Naghmah.strings.wishlistRemoved || "");
        if (originRoot) {
          focusElementForA11y(originRoot.querySelector(".wishlist-page__empty-title"));
        }
        return;
      }

      var retryButton = evt.target.closest("[data-wishlist-retry]");
      if (retryButton) {
        evt.preventDefault();
        retryCard(retryButton);
        return;
      }

      var removeButton = evt.target.closest("[data-wishlist-remove-unavailable]");
      if (removeButton) {
        evt.preventDefault();
        removeUnavailableCard(removeButton);
        return;
      }
    });

    /* مزامنة عبر تبويب آخر: أي تعديل على نفس المفتاح من تبويب/نافذة
       أخرى لهذا الجهاز والمتصفح يُطلق storage event هنا (لا يُطلق في
       التبويب الذي أجرى التعديل نفسه). */
    window.addEventListener("storage", function (evt) {
      if (evt.key !== STORAGE_KEY) return;
      handleExternalStorageChange();
    });

    /* Final Integration Audit (2026-07): naghmah:product-changed تُطلَق
       فعليًا من assets/product.js بعد كل استبدال Combined Listing ناجح (لا
       تعديل على product.js هنا إطلاقًا — الحدث موجود ومُطلَق مسبقًا بهذا
       الاسم بالضبط، مع event.detail.pageRoot = الجذر الجديد المُستورَد).
       مزامنة فورية لزر/أزرار المفضلة داخل هذا الجذر تحديدًا، دون انتظار
       الدورة التالية للـMutationObserver العالمية — نفس نمط compare.js
       المُختبَر فعليًا منذ Compare V2. */
    document.addEventListener("naghmah:product-changed", function (evt) {
      if (!evt || !evt.detail || !evt.detail.pageRoot) return;
      syncToggleButtonsWithin(evt.detail.pageRoot, readItems());
    });
  }

  if (Naghmah.registerSection) {
    Naghmah.registerSection("main-wishlist", initWishlistPageSection);
  }

  /* أي قسم آخر يُعاد تحميله من محرر الثيم قد يحمل أزرار Toggle جديدة
     تحتاج مزامنة فورية مع حالة المفضلة الحالية. */
  document.addEventListener("shopify:section:load", function (evt) {
    var wrapper = evt.target;
    if (!wrapper || !wrapper.querySelector) return;
    syncAllToggleButtons();
    updateCountBadges(readItems().length);
  });

  /* بند 8: يدعم كون wrapper نفسه هو قسم Wishlist (matches) أو يحويه
     (querySelector) — الحالتان معًا كانتا موثَّقتين في طلب صاحبة
     المشروع صراحة. إلغاء Run الخاصة بهذا الجذر فقط عبر cancelRun (يُزيل
     مهامها من الطابور العالمي ويُلغي Controllers الخاصة بها فقط)، بلا
     أي تأثير على أي قسم main-wishlist آخر معروض بالتوازي — طلباته تبقى
     في الطابور العالمي كما هي تمامًا. */
  document.addEventListener("shopify:section:unload", function (evt) {
    var wrapper = evt.target;
    if (!wrapper || !wrapper.querySelector) return;
    var root =
      wrapper.matches && wrapper.matches('[data-section-type="main-wishlist"]')
        ? wrapper
        : wrapper.querySelector('[data-section-type="main-wishlist"]');
    if (!root) return;

    var state = wishlistPageStates.get(root);
    if (state && state.currentRun) {
      cancelRun(state.currentRun);
    }
    wishlistPageStates.delete(root);
  });

  Naghmah.onReady(function () {
    bindDelegatedListeners();
    initWishlistMutationObserver();
    syncAllToggleButtons();
    updateCountBadges(readItems().length);
    document
      .querySelectorAll('[data-section-type="main-wishlist"]')
      .forEach(function (root) {
        initWishlistPageSection(root);
      });
  });
})();
